var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationShipmentArrived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 18V30L20 38L33 31V18M7 18L20 25.5L33 18M7 18L15.5 13M33 18L24 13",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.5V37.5",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8341 18.1211C17.8273 15.1109 14.3154 11.0305 14.3154 7.51863C14.3154 4.47566 16.7911 2 19.8341 2C22.877 2 25.3527 4.47566 25.3527 7.51863C25.3527 11.0305 21.8408 15.1109 19.8341 18.1211Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 9.22949C18.8903 9.22949 18.123 8.46224 18.123 7.51927C18.123 6.5763 18.8903 5.80905 19.8333 5.80905C20.7762 5.80905 21.5435 6.5763 21.5435 7.51927C21.5435 8.46224 20.7762 9.22949 19.8333 9.22949Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationShipmentArrived);
export default __webpack_public_path__ + "static/media/notification-shipment-arrived.a5544a781fb0ab8ef898b7f45c2d5565.svg";
export { ForwardRef as ReactComponent };